import { api } from 'api'
import { format } from 'date-fns'
import { stringify } from 'qs'

export enum VndlyTimesheetIssue {
  WORK_ORDER_NOT_FOUND = 'work_order_not_found',
}

type ListVndlyTimesheetIssuesParams = {
  companyIds: number[]
  startDate: Date
  endDate: Date
}

type ListVndlyTimesheetIssuesResponseWorkOrderAssociationIssueItem = {
  companyId: number
  companyName: string
  positionId: number
  positionName: string
  workerId: number
  workerName: string
  vndlyJobTitle: string | null
  vndlyCandidateUniqueId: string | null
  issues: VndlyTimesheetIssue[]
}

type ListVndlyTimesheetIssuesResponse = {
  requiresWorkWhileAdminIntervention: boolean
  workOrderAssociationIssues: ListVndlyTimesheetIssuesResponseWorkOrderAssociationIssueItem[]
}

export async function listVndlyTimesheetIssues(
  params: ListVndlyTimesheetIssuesParams,
  signal?: AbortSignal
) {
  const response = await api.get<ListVndlyTimesheetIssuesResponse>(
    '/company/vndly/timesheet/issues',
    {
      params: {
        companyIds: params.companyIds,
        startDate: format(params.startDate, 'yyyy-MM-dd'),
        endDate: format(params.endDate, 'yyyy-MM-dd'),
      },
      paramsSerializer: (queryParams) =>
        stringify(queryParams, { arrayFormat: 'repeat', indices: false }),
      signal,
    }
  )

  return response.data
}
